import apiClient from '../api.js';

// Capa de servicios para el CRUD de facturas de estudiante (`unicen.factura` + `unicen.factura_historial`).
//
// Contrato asumido (backend en capas, `modules/facturacion`): igual que
// `useEstudianteNotasApi.js`, las respuestas de error exponen el mensaje vía `.mensaje`.
//
//   GET    /facturacion/facturas?unicodigo=&id_sede=
//          -> { data: [{ origen: 'CAJA'|'HISTORIAL', id, unicodigo, id_sede, id_gestion,
//                         id_item_seguimiento, numero_factura, fecha_factura, monto_cubierto,
//                         estado, activo, codigo_control, id_tipo_moneda, id_tasa_cambio,
//                         id_talonario, id_transaccion_caja, tpago, id_personal,
//                         descripcion_item, nombre_gestion, observacion, monto_deuda }] }
//          Combina la vista `factura` (origen CAJA) y la tabla `factura_historial`
//          (origen HISTORIAL): `origen` + `id` identifican de forma única cada fila y son
//          obligatorios para actualizar/eliminar.
//
//   GET    /facturacion/facturas/items-disponibles?id_sede=
//          -> { data: [{ id_item_seguimiento, descripcion, prioridad }] }
//
//   POST   /facturacion/facturas
//          body: { unicodigo, id_sede, id_gestion, id_item_seguimiento, numero_factura,
//                  fecha_factura, monto_cubierto, tpago, id_usuario }
//          -> { data: { ...<fila creada, origen CAJA>, deuda }, mensaje }
//          `deuda` (mismo formato que en DELETE) dice qué pasó con la deuda del ítem: registrar un
//          pago la RECALCULA (`total − descuento − pagado`) en la misma transacción.
//          Siempre crea una factura "de caja" (inserta en transaccion_caja +
//          detalle_transaccion + seguimiento_caja, las tablas base de la vista).
//
//   PUT    /facturacion/facturas/:origen/:id
//          body: PATCH real — solo hace falta mandar las claves que cambian (de
//                { numero_factura, fecha_factura, monto_cubierto, id_item_seguimiento,
//                id_gestion, id_sede, estado, activo, id_tipo_moneda, id_tasa_cambio, tpago });
//                lo que no se manda queda como estaba.
//          -> { data: { ...<fila actualizada>, deuda, deuda_anterior }, mensaje }
//          Editar monto/ítem/gestión/sede recalcula la deuda del ítem; `deuda_anterior` solo viene
//          si el pago cambió de ítem, gestión o sede (la deuda de donde salió).
//
//   DELETE /facturacion/facturas/:origen/:id
//          body: { id_usuario } (operador que anula — obligatorio, va en el body porque
//                DELETE no admite query params claros para esto en axios sin `data`)
//          -> { data: { ...<fila anulada>, deuda: { estado, id_deudas_contable, saldo_anterior,
//                         saldo_nuevo, total, pagado, creada, requiere_revision, aviso } }, mensaje }
//          Anula la factura: la mueve a `factura_historial_anuladas` y RECALCULA la deuda del
//          estudiante (`total - descuento - pagado`, sin sumar a ciegas). NO es un borrado simple.
//          Si `deuda.requiere_revision` es true (AMBIGUA / SIN_TOTAL / EN_DOLARES) la factura se
//          anuló pero el saldo NO se tocó: `deuda.aviso` dice por qué.

const resource = '/facturacion/facturas';

const useEstudianteFacturasApi = {
  listar(unicodigo, idSede) {
    return apiClient.get(resource, { params: { unicodigo, id_sede: idSede } });
  },

  listarItemsDisponibles(idSede) {
    return apiClient.get(`${resource}/items-disponibles`, { params: { id_sede: idSede } });
  },

  crear(datos) {
    return apiClient.post(resource, datos);
  },

  actualizar(origen, id, datos) {
    return apiClient.put(`${resource}/${origen}/${id}`, datos);
  },

  eliminar(origen, id, idUsuario) {
    return apiClient.delete(`${resource}/${origen}/${id}`, { data: { id_usuario: idUsuario } });
  },
};

export default useEstudianteFacturasApi;
